import React, { useState } from "react";
import { FormLabel } from "../form-label/form-label";
import { When } from "../when";
import { BasicMultiSelectTriggerForVirtualizedSelect } from "./triggers/basic-mutli-select-trigger";
import { BasicSelectTriggerForVirtualizedSelect } from "./triggers/basic-select-trigger";
import { VirtualizedSelect, VirtualSelectProps } from "./virtualized-select";
import { ValidationMessage } from "@/flokit/core/validation-message/validation-message";

interface AutoOpenVirtualizedSelectProps
  extends Omit<VirtualSelectProps, "open" | "onOpenChange"> {}

interface AutoOpenVirtualizedSelectViewProps
  extends AutoOpenVirtualizedSelectProps {
  required?: boolean;
  label?: string;
  tooltip?: string;
  name?: string;
  isMulti?: boolean;
  placeholder?: string;
  triggerClassName?: string;
  validationMsg?: string;
  shouldShowValidation?: boolean;
  side?: "top" | "bottom" | "right" | "left";
  avoidCollisions?: boolean;
}

const AutoOpenVirtualizedSelect = (
  props: AutoOpenVirtualizedSelectProps,
) => {
  const [open, setOpen] = useState(false);

  return (
    <VirtualizedSelect
      {...props}
      open={open}
      onOpenChange={setOpen}
      onSelectItem={(item) => {
        setOpen(false);
        props.onSelectItem(item);
      }}
    />
  );
};

export const AutoOpenVirtualizedSelectView = (
  props: AutoOpenVirtualizedSelectViewProps,
) => {
  const { required, label, name, tooltip, isMulti, placeholder, ...rest } =
    props;
  const selected = props.options.filter((i) => props.isItemSelected(i));
  const displayValue =
    selected.length > 0 ? selected.map((x) => x.label).join(" ") : "";
  return (
    <section className="flex flex-col gap-y-2">
      <FormLabel
        required={required}
        label={label}
        name={name}
        tooltip={tooltip}
      />
      <AutoOpenVirtualizedSelect {...rest}>
        <When condition={isMulti} key={"is-multi"}>
          <BasicMultiSelectTriggerForVirtualizedSelect
            values={selected}
            placeholder={placeholder}
          />
        </When>
        <When condition={!isMulti} key={"is-single"}>
          <BasicSelectTriggerForVirtualizedSelect
            placeholder={placeholder}
            displayLabel={displayValue}
            disabled={props.disabled}
          />
        </When>
      </AutoOpenVirtualizedSelect>

      <ValidationMessage
        shouldShowValidation={props.shouldShowValidation}
        validationMessage={props.validationMsg}
      />
    </section>
  );
};
